/**
 * You have to add attributes data-show-more-btn="<id>" to btn and
 * data-rolled-up-block="<id>" to text block element and function will
 * toggle class "opened" for them
 */
// eslint-disable-next-line no-extra-semi
;(function manageTextShortening() {
  const openBtns = document.querySelectorAll('[data-show-more-btn]')

  openBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      const btnAttribute = this.getAttribute('data-show-more-btn')
      const textContainer = document.querySelector(`[data-rolled-up-block="${btnAttribute}"]`)

      if (textContainer) {
        this.classList.toggle('opened')
        textContainer.classList.toggle('opened')
      }
    })
  })
})()
